import { Modal, ROLE } from 'baseui/modal'
import { SIZE } from 'baseui/button'
import ActionTile from '@/containers/SubscriptionFormPageNew/Components/shared/ActionTile/ActionTile'
import useAbandonContract from './useAbandonContract'
import AbandonModalContent from '@/shared/components/contracts/AbandonModalContent'
import IconCarbonTrashCan from '@/shared/icons/IconCarbonTrashCan'

const AbandonContract = () => {
  const { t, isOpen, openModal, closeModal, canShowAbandonButton, isAlreadyRetracted, handleSubmit } =
    useAbandonContract()

  if (!canShowAbandonButton || isAlreadyRetracted) {
    return null
  }

  return (
    <>
      <ActionTile label={t('subscriptionTable:abandon')} icon={<IconCarbonTrashCan size={18} />} onClick={openModal} />
      <Modal onClose={closeModal} isOpen={isOpen} animate autoFocus size={SIZE.full} role={ROLE.dialog}>
        <AbandonModalContent onSubmit={handleSubmit} minLength={10} />
      </Modal>
    </>
  )
}

export default AbandonContract
